import { createBrowserRouter, Link, RouterProvider } from 'react-router-dom';
import Layout from './components/Layout';
import ShipmentPage from './pages/ShipmentPage';
import AddressBookPage from './pages/AddressBookPage';
import BulkShipPage from './pages/BulkShipPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import SettingsPage from './pages/SettingsPage';
import PrintPage from './pages/PrintPage';
import ApiConfigGate from './components/ApiConfigGate';

/** In-app fallback for mistyped or stale URLs, rendered inside the Layout shell. */
function NotFoundPage() {
  return (
    <div className="panel" style={{ maxWidth: '480px', margin: '40px auto', textAlign: 'center', padding: '40px' }}>
      <h2 style={{ marginBottom: '12px' }}>Page Not Found</h2>
      <p style={{ marginBottom: '24px', color: 'var(--aged-mahogany-light)' }}>
        This page does not exist. Check the address or head back to the console.
      </p>
      <Link to="/" className="btn btn-primary">Back to Create Shipment</Link>
    </div>
  );
}

/**
 * Route-level error fallback so an unexpected render/route error shows an
 * in-app message instead of React Router's unstyled default page. A plain
 * anchor (full reload) recovers from broken in-memory state.
 */
function RouteErrorPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="panel" style={{ maxWidth: '480px', textAlign: 'center', padding: '40px' }}>
        <h2 style={{ marginBottom: '12px' }}>Something Went Wrong</h2>
        <p style={{ marginBottom: '24px', color: 'var(--aged-mahogany-light)' }}>
          An unexpected error occurred while showing this page.
        </p>
        <a href="/" className="btn btn-primary">Back to Create Shipment</a>
      </div>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: '/print',
    element: <ApiConfigGate><PrintPage /></ApiConfigGate>,
    errorElement: <RouteErrorPage />,
  },
  {
    path: '/',
    element: <ApiConfigGate><Layout /></ApiConfigGate>,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <ShipmentPage /> },
      { path: 'addresses', element: <AddressBookPage /> },
      { path: 'bulk-ship', element: <BulkShipPage /> },
      { path: 'orders', element: <OrderHistoryPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
